<template>
  <b-card>
    <b-card-body>
      <ul v-for="(v,vi) in data" :key="vi">
        <li>{{v.name}} - {{v.value}}</li>
      </ul>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props : ['data'],
  name: "gravy_packaging_list",
  data(){
    return {

    }
  }
}
</script>

<style scoped>

</style>